import React, { useContext, useRef, useState, useEffect } from "react";
import { AuthContext } from "../context/auth";
import { useForm } from "../util/hooks";
import axios from "axios";
import { Mensaje } from "../components/mensajes";
import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import { Loader, Dimmer } from "semantic-ui-react";
import { MensajeOlvidarClave } from "./recuperarClave";
import "../../src/mantenimiento.css";
import CatalogoSistema from "../catalogosAthos/catalogoSistema";

function Login(props) {
  const [loading, setLoading] = useState(false);

  let op = require("../../public/modulos/datos");

  const context = useContext(AuthContext);

  const { onChange, onSubmit, values } = useForm(loginUserCallback, {
    username: "",
    password: "",
  });
  const [tipoInput, setTipoInput] = useState("password");
  const [iconeye, setIconEye] = useState("fas fa-eye");
  // Bloquea el autocompletado/guardado de clave del navegador. El campo inicia
  // readonly y se libera al tocarlo: onTouchStart/onPointerDown se disparan en
  // móvil ANTES de que aparezca el teclado, por lo que sí funciona en móvil.
  const [bloqueoPass, setBloqueoPass] = useState(true);
  const [modalClave, setModalClave] = useState(false);
  const [modalSistema, setModalSistema] = useState({
    mostrar: false,
    idfranquicia: null
  });

  const txtUserName = useRef(null);
  const txtPassword = useRef(null);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [activo, setActivo] = useState(true);

  const verificar = () => {
    let endpoint = op.validar + `/api/athos/sistema/verificar/5`;
    axios
      .post(endpoint)
      .then(function (response) {
        if (response.status === 200) {
          setActivo(response.data.activo);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const sinIgn = async (idorg = null) => {
    setLoading(true);
    let endpoint = op.conexion + "/api/athos/auth/signin";

    var login = values.username;
    var passwd = values.password;

    axios
      .post(endpoint, {
        login: login,
        passwd: passwd,
        idorg: idorg,
      })
      .then(function (response) {
        if (response.status === 200) {
          context.login(response.data.token);
          if (response.data.token === null) {
            props.history.push("/");
          } else {
            sessionStorage.setItem(
              "txtmodulo",
              JSON.stringify(response.data.txtmodulo)
            );
            sessionStorage.setItem(
              "txtfranquicia",
              JSON.stringify(response.data.txtfranquicia)
            );
            sessionStorage.setItem(
              "idusuario",
              JSON.stringify(response.data.idusuario)
            );
            sessionStorage.setItem(
              "idagente",
              JSON.stringify(response.data.idagente)
            );
            sessionStorage.setItem(
              "numcaja",
              JSON.stringify(response.data.numcaja)
            );
            sessionStorage.setItem(
              "login",
              JSON.stringify(response.data.login)
            );
            sessionStorage.setItem(
              "fechasistema",
              JSON.stringify(response.data.fechasistema)
            );
            sessionStorage.setItem(
              "anioactu",
              JSON.stringify(response.data.anioactu)
            );
            sessionStorage.setItem(
              "idorganizacion",
              JSON.stringify(response.data.idorganizacion)
            );
            sessionStorage.setItem(
              "permisos",
              JSON.stringify(response.data.permisos)
            );
            sessionStorage.setItem(
              "accconfiggene",
              JSON.stringify(response.data.accconfiggene)
            );
            sessionStorage.setItem(
              "accopbd",
              JSON.stringify(response.data.accopbd)
            );
            sessionStorage.setItem(
              "accinventarioc",
              JSON.stringify(response.data.accinventarioc)
            );
            sessionStorage.setItem(
              "accventasc",
              JSON.stringify(response.data.accventasc)
            );
            sessionStorage.setItem(
              "acccomprasc",
              JSON.stringify(response.data.acccomprasc)
            );
            sessionStorage.setItem(
              "acccontabilidadc",
              JSON.stringify(response.data.acccontabilidadc)
            );
            sessionStorage.setItem(
              "accfinanzasc",
              JSON.stringify(response.data.accfinanzasc)
            );
            sessionStorage.setItem(
              "accbtnregalmacenc",
              JSON.stringify(response.data.accbtnregalmacenc)
            );
            sessionStorage.setItem(
              "accbtnubialmacenc",
              JSON.stringify(response.data.accbtnubialmacenc)
            );
            sessionStorage.setItem(
              "accbtnumedidac",
              JSON.stringify(response.data.accbtnumedidac)
            );
            sessionStorage.setItem(
              "accbtnmarcac",
              JSON.stringify(response.data.accbtnmarcac)
            );
            sessionStorage.setItem(
              "accbtnmodeloc",
              JSON.stringify(response.data.accbtnmodeloc)
            );
            sessionStorage.setItem(
              "accbtntproductoc",
              JSON.stringify(response.data.accbtntproductoc)
            );
            sessionStorage.setItem(
              "accbtnproductoc",
              JSON.stringify(response.data.accbtnproductoc)
            );
            sessionStorage.setItem(
              "accbtnopinventarioc",
              JSON.stringify(response.data.accbtnopinventarioc)
            );
            sessionStorage.setItem(
              "accbtnactxlsxc",
              JSON.stringify(response.data.accbtnactxlsxc)
            );
            sessionStorage.setItem(
              "accbtntvaciosc",
              JSON.stringify(response.data.accbtntvaciosc)
            );
            sessionStorage.setItem(
              "accbtnireportsc",
              JSON.stringify(response.data.accbtnireportsc)
            );
            sessionStorage.setItem(
              "accbtnclientesc",
              JSON.stringify(response.data.accbtnclientesc)
            );
            sessionStorage.setItem(
              "accbtnvendedorc",
              JSON.stringify(response.data.accbtnvendedorc)
            );
            sessionStorage.setItem(
              "accbtnpedidosc",
              JSON.stringify(response.data.accbtnpedidosc)
            );
            sessionStorage.setItem(
              "accbtnnentregac",
              JSON.stringify(response.data.accbtnnentregac)
            );
            sessionStorage.setItem(
              "accbtnndebitoc",
              JSON.stringify(response.data.accbtnndebitoc)
            );
            sessionStorage.setItem(
              "accbtnfacturasc",
              JSON.stringify(response.data.accbtnfacturasc)
            );
            sessionStorage.setItem(
              "accbtnpresupuestoc",
              JSON.stringify(response.data.accbtnpresupuestoc)
            );
            sessionStorage.setItem(
              "accbtnvreportsc",
              JSON.stringify(response.data.accbtnvreportsc)
            );
            sessionStorage.setItem(
              "accbtnproveedoresc",
              JSON.stringify(response.data.accbtnproveedoresc)
            );
            sessionStorage.setItem(
              "accbtnordencomprac",
              JSON.stringify(response.data.accbtnordencomprac)
            );
            sessionStorage.setItem(
              "accbtnfactucomprac",
              JSON.stringify(response.data.accbtnfactucomprac)
            );
            sessionStorage.setItem(
              "accbtncreportsc",
              JSON.stringify(response.data.accbtncreportsc)
            );
            sessionStorage.setItem(
              "accbtncntcontablec",
              JSON.stringify(response.data.accbtncntcontablec)
            );
            sessionStorage.setItem(
              "accbtnastcntablec",
              JSON.stringify(response.data.accbtnastcntablec)
            );
            sessionStorage.setItem(
              "accbtnmvbancariosc",
              JSON.stringify(response.data.accbtnmvbancariosc)
            );
            sessionStorage.setItem(
              "accbtnmvbancariostc",
              JSON.stringify(response.data.accbtnmvbancariostc)
            );
            sessionStorage.setItem(
              "accbtnvinculacuentac",
              JSON.stringify(response.data.accbtnvinculacuentac)
            );
            sessionStorage.setItem(
              "accbtncntreportsc",
              JSON.stringify(response.data.accbtncntreportsc)
            );
            sessionStorage.setItem(
              "accbtnbancosc",
              JSON.stringify(response.data.accbtnbancosc)
            );
            sessionStorage.setItem(
              "accbtnbeneficiariosc",
              JSON.stringify(response.data.accbtnbeneficiariosc)
            );
            sessionStorage.setItem(
              "accbtnctsbancariasc",
              JSON.stringify(response.data.accbtnctsbancariasc)
            );
            sessionStorage.setItem(
              "accbtncnciliabancariac",
              JSON.stringify(response.data.accbtncnciliabancariac)
            );
            sessionStorage.setItem(
              "accbtncntxcobrarc",
              JSON.stringify(response.data.accbtncntxcobrarc)
            );
            sessionStorage.setItem(
              "accbtncntxpagarc",
              JSON.stringify(response.data.accbtncntxpagarc)
            );
            sessionStorage.setItem(
              "accbtntipretencionesc",
              JSON.stringify(response.data.accbtntipretencionesc)
            );
            sessionStorage.setItem(
              "accbtnfreportsc",
              JSON.stringify(response.data.accbtnfreportsc)
            );
            sessionStorage.setItem(
              "accopuserc",
              JSON.stringify(response.data.accopuserc)
            );
            sessionStorage.setItem(
              "accopuserappc",
              JSON.stringify(response.data.accopuserappc)
            );
            sessionStorage.setItem(
              "accvaciosc",
              JSON.stringify(response.data.accvaciosc)
            );
            sessionStorage.setItem(
              "btnopvaciosc",
              JSON.stringify(response.data.btnopvaciosc)
            );
            sessionStorage.setItem(
              "btncontvaciosc",
              JSON.stringify(response.data.btncontvaciosc)
            );
            sessionStorage.setItem(
              "btnclasvaciosc",
              JSON.stringify(response.data.btnclasvaciosc)
            );
            sessionStorage.setItem(
              "btnreportvaciosc",
              JSON.stringify(response.data.btnreportvaciosc)
            );
            sessionStorage.setItem(
              "accserviciosc",
              JSON.stringify(response.data.accserviciosc)
            );
            sessionStorage.setItem(
              "btnreportservc",
              JSON.stringify(response.data.btnreportservc)
            );
            sessionStorage.setItem(
              "ordserviciosc",
              JSON.stringify(response.data.ordserviciosc)
            );
            sessionStorage.setItem(
              "accmovilesc",
              JSON.stringify(response.data.accmovilesc)
            );
            sessionStorage.setItem(
              "accgserviciosc",
              JSON.stringify(response.data.accgserviciosc)
            );

            sessionStorage.setItem(
              "accpostventasc",
              JSON.stringify(response.data.accpostventasc)
            );
            sessionStorage.setItem(
              "postventac",
              JSON.stringify(response.data.postventac)
            );
            sessionStorage.setItem(
              "accinicioc",
              JSON.stringify(response.data.accinicioc)
            );
            sessionStorage.setItem(
              "accbtnfacturaxnotasc",
              JSON.stringify(response.data.accbtnfacturaxnotasc)
            );
            sessionStorage.setItem("post", JSON.stringify(response.data));
            sessionStorage.setItem("logo", JSON.stringify(response.data.logo));
            sessionStorage.setItem(
              "organizacion",
              JSON.stringify(response.data.organizacion)
            );
            sessionStorage.setItem(
              "riforganizacion",
              JSON.stringify(response.data.riforganizacion)
            );
            sessionStorage.setItem("idefiscal", 1);
            window.location.href = "/inicio";
          }
        }
      })
      .catch(function (error) {
        if (error.response) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: error.response.data.message,
            icono: "error",
          });
        }
      })
      .finally(function () {
        setLoading(false);
      });
  };

  async function loginUserCallback() {
    if (
      values.username === "sistema" ||
      values.username === "sistema2" ||
      values.username === "bimbo"
    ) {
      setModalSistema({
        mostrar: true,
        idfranquicia: values.username === "bimbo" ? 3 : 5
      });
    } else {
      await sinIgn();
    }
  }

  const onHideSistema = (value) => {
    setModalSistema({
      mostrar: false,
      idfranquicia: null,
    });

    if (value) {
      sinIgn(value.idorganizacion);
    }
  };

  const mostrarClave = () => {
    if (tipoInput === "password") {
      setTipoInput("text");
      setIconEye("fas fa-eye-slash");
    } else {
      setTipoInput("password");
      setIconEye("fas fa-eye");
    }
  };

  // Libera el campo de contraseña (quita readonly) al interactuar con él.
  // Idempotente: no importa cuántas veces se dispare.
  const desbloquearPassword = (e) => {
    e.currentTarget.removeAttribute("readonly");
    setBloqueoPass(false);
  };

  useEffect(() => {
    verificar();
  }, []);

  return activo ? (
    <div className="contenedor">
      <section className="baner" style={{ margin: 0, pading: 0 }}>
        <img
          className="img-fluid d-none d-sm-block"
          style={{ width: "100%", height: "100%" }}
          src="imagenes/almacen2.png"
        />
        <img
          className="img-fluid d-sm-none"
          style={{ width: "100%", height: "100%" }}
          src="imagenes/almacen2.png"
        />

        <div className="baner-content">
          <Fade top>
            <div className="navh fixed d-none d-xl-block">
              <div className="container mx-auto justify-content-between">
                <Fade left>
                  <div className="navLogo d-flex ">
                    <img
                      className="img-fluid logoSygre"
                      src="imagenes/im4.png"
                    />
                  </div>
                  <div className="container-fluid text-center d-none d-sm-block contenedor-label">
                    {/* <label> SISTEMA DE ALMACEN</label> */}
                    <br />
                    {/*  <label> GESTION DE TRIBUTOS ESTADALES</label> */}
                  </div>
                </Fade>
              </div>
            </div>
          </Fade>
          {/* <div className='sistema d-none d-xl-block'>

            <h1><span className='span1'><strong>ATHOS-</strong></span><span className='span2'>ERP</span></h1>
          </div> */}
          <Zoom>
            <div className="boder text-center d-none d-sm-block col align-self-center">
              <div className="col-12 user-img">
                {/*                 <img src={op.imagenes + '/imagen?img=logo.png'} alt="" /> */}
                <img className="img-fluid" src="imagenes/prue.jpg" />
              </div>
              <div className="sistemad">
                <h1>
                  <span className="span1">
                    <strong>ATHOS-</strong>
                  </span>
                  <span className="span2">ERP</span>
                </h1>
              </div>
              <div style={{ overflow: "auto", height: "50vh" }}>
                <form onSubmit={onSubmit} className="mb-5" autoComplete="off">
                  <Dimmer active={loading} inverted>
                    <Loader inverted>cargando...</Loader>
                  </Dimmer>

                  <div className="input-group mt-5">
                    <input
                      autoFocus
                      ref={txtUserName}
                      type="text"
                      autoComplete="username"
                      data-lpignore="true"
                      className="form-control input2"
                      required
                      placeholder="Usuario:"
                      name="username"
                      value={values.username}
                      onKeyPress={(event) => {
                        if (event.which === 13) {
                          txtPassword.current.focus();
                        }
                      }}
                      onChange={onChange}
                    />
                  </div>

                  <div className="input-group mt-3">
                    <input
                      ref={txtPassword}
                      type={tipoInput}
                      autoComplete="new-password"
                      data-lpignore="true"
                      readOnly={bloqueoPass}
                      onTouchStart={desbloquearPassword}
                      onPointerDown={desbloquearPassword}
                      onFocus={desbloquearPassword}
                      className="form-control input2"
                      required
                      placeholder="Contraseña:"
                      name="password"
                      value={values.password}
                      onChange={onChange}
                    />
                    <button
                      type="button"
                      style={{ border: "none" }}
                      onClick={mostrarClave}
                      className="text-light rounded bg-transparent border-bottom border-light"
                    >
                      <i className={iconeye}></i>{" "}
                    </button>
                  </div>

                  <button type="submit" className="boton rounded-pill">
                    <i className="fas fa-sign-in-alt"></i> Ingresar
                  </button>
                </form>
                <button
                  onClick={() => setModalClave(true)}
                  className=" btn col-12 btn-link btn-sm my-1"
                >
                  <i className="fas fa-lock"></i> recuperar Contraseña
                </button>
              </div>
            </div>
          </Zoom>

          <div className="container boder2 text-center d-sm-none ">
            <div className="col-12 user-img2 ">
              <img className="img-fluid" src="imagenes/prue.jpg" />
              {/* <img src={op.imagenes + '/imagen?img=logo.png'} alt="" /> */}
            </div>
            <div className="sistemad">
              <h1>
                <span className="span1">
                  <strong>ATHOS-</strong>
                </span>
                <span className="span2">ERP</span>
              </h1>
            </div>
            <div className="login-form-box">
              <form onSubmit={onSubmit} autoComplete="off">
                <Dimmer active={loading} inverted>
                  <Loader inverted>cargando...</Loader>
                </Dimmer>

                <div className="input-group mt-4">
                  <input
                    type="text"
                    autoComplete="username"
                    data-lpignore="true"
                    className="inpt form-control"
                    required
                    placeholder="Usuario:"
                    name="username"
                    value={values.username}
                    onChange={onChange}
                  />
                </div>

                <div className="input-group mt-4">
                  <input
                    type={tipoInput}
                    autoComplete="new-password"
                    data-lpignore="true"
                    readOnly={bloqueoPass}
                    onTouchStart={desbloquearPassword}
                    onPointerDown={desbloquearPassword}
                    onFocus={desbloquearPassword}
                    className="inpt form-control"
                    required
                    placeholder="Contraseña:"
                    name="password"
                    value={values.password}
                    onChange={onChange}
                  />
                  <button
                    type="button"
                    style={{ border: "none" }}
                    onClick={mostrarClave}
                    className="text-light rounded bg-transparent border-bottom border-light"
                  >
                    <i className={iconeye}></i>{" "}
                  </button>
                </div>

                <button type="submit" className="boton rounded-pill">
                  <i className="fas fa-sign-in-alt"></i> Ingresar
                </button>
              </form>
              <button
                onClick={() => setModalClave(true)}
                className=" btn col-12 btn-link btn-sm my-1"
              >
                <i className="fas fa-lock"></i> recuperar Contraseña
              </button>
            </div>
          </div>
        </div>
        <footer className="footer fixed-bottom text-center text-light">
          <strong>
            Copyright © 2023 <a href="#">Sygreca</a>.
          </strong>
          Todos los Derechos Reservados.
        </footer>
      </section>
      <MensajeOlvidarClave
        show={modalClave}
        onHide={() => setModalClave(false)}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />

      <CatalogoSistema
        show={modalSistema.mostrar}
        idfranquicia={modalSistema.idfranquicia}
        onHide={onHideSistema}
      />
    </div>
  ) : (
    <div className="coverPage">
      <div className="__coverPage-content">
        <h1>
          <strong>ATHOS-</strong>ERP
        </h1>
        <h3>
          Estamos construyendo algo <span>FANTASTICO!</span>
        </h3>
        <p>www.sygreca.com.ve</p>
        <div className="socialMedia">
          <a className="socialIcon" href="#">
            <i className="fas fa-envelope"></i>
          </a>
          <a className="socialIcon" href="#">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a className="socialIcon" href="#">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/login.js